module.exports = "/_next/static/images/Iso27018Badge@2x-e33463a4afbf52e121915440fb8d2231.png";